import React from "react";

function EditTitleInNotebook({ 
    isEditingTitle,
    editingTitleValue,
    setEditingTitleValue,
    handleTitleKeyPress,
    handleTitleSave,
    handleTitleCancel,
    handleTitleEdit,
    notebook
}) {
    return (
        <>
            {/* Title Editing */}
            {isEditingTitle ? (
                <div className="title-editing-container">
                    <input
                        type="text"
                        value={editingTitleValue}
                        onChange={(e) => setEditingTitleValue(e.target.value)}
                        onKeyPress={handleTitleKeyPress}
                        className="title-editing-input"
                        placeholder="Enter notebook title"
                    />
                    <button 
                        className="title-save-button"
                        onClick={handleTitleSave}
                        title="Save title"
                    >
                        <i className="fas fa-check"></i>
                    </button>
                    <button 
                        className="title-cancel-button"
                        onClick={handleTitleCancel}
                        title="Cancel"
                    >
                        <i className="fas fa-times"></i>
                    </button>
                </div>
            ) : (
                <div className="notebook-title-container" onClick={handleTitleEdit}>
                    <h2 className="notebook-title">{notebook.title}</h2>
                    <i className="fas fa-pencil-alt title-edit-icon"></i>
                </div>
            )}
        </>
    );
}

export default EditTitleInNotebook;